// extracted by mini-css-extract-plugin
module.exports = {"content":"ConfirmDeleteModal_content__R7m7H","fileName":"ConfirmDeleteModal_fileName__26_qG"};